import {
    EuiButtonEmpty,
    EuiDescriptionList,
    EuiDescriptionListDescription,
    EuiDescriptionListTitle,
    EuiFlexGroup,
    EuiFlexItem,
    EuiIcon,
    EuiLoadingSpinner,
    EuiText,
} from "@elastic/eui";
import React, { useState } from "react";
import _ from "lodash";
import moment from "moment";
import { useForm } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import AbstractNumber from "../../../../shared/entity/components/AbstractFormField/fields/AbstractNumber";
import TripFieldForm from "../../shared/TripFieldForm";

import AbstractDate from "../../../../shared/entity/components/AbstractFormField/fields/AbstractDate";
import AbstractSelect from "../../../../shared/entity/components/AbstractFormField/fields/AbstractSelect";
import AbstractString from "../../../../shared/entity/components/AbstractFormField/fields/AbstractString";
import {
    dateToFormattedFullDateAndTime,
    isValidDate,
    secondsToHoursAndMinutes,
} from "../../../../../utils/dateAndTime";
import DocumentsModal from "../../shared/DocumentsModal";

const mapDropOffValue = (type, value) =>
    _.isNumber(value) || (!_.isNumber(value) && !!value)
        ? type === "duration"
            ? secondsToHoursAndMinutes(value)
            : type === "dateAndTime" && typeof value === "string"
            ? dateToFormattedFullDateAndTime(value)
            : type === "attachment"
            ? value.length
            : value
        : "N/A";

function DropoffAccordionSection({
    iconType,
    title,
    value,
    isEditable,
    onDropOffFieldChange,
    fieldType,
    fieldName,
    pointName,
}) {
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const { handleSubmit, register, control } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const successCallBack = () => setIsLoading(false);
    const intl = useIntl();

    const closePopover = () => {
        setIsPopoverOpen(false);
    };
    const openPopover = () => {
        setIsPopoverOpen(true);
    };

    const onSubmit = (value) => {
        setIsLoading(true);
        onDropOffFieldChange(fieldName, value, () => {
            successCallBack();
            closePopover();
        });
    };

    const renderInput = () => {
        const options = { label: title, name: fieldName };
        const errors = {};
        const entityObject = {
            [fieldName]: fieldType === "dateAndTime" && value ? moment(value) : value,
        };

        switch (fieldType) {
            case "number":
                return (
                    <AbstractNumber
                        options={options}
                        errors={errors}
                        entityObject={entityObject}
                        register={register}
                    />
                );
            case "dateAndTime":
                return (
                    <AbstractDate
                        options={options}
                        errors={errors}
                        entityObject={entityObject}
                        register={register}
                        control={control}
                    />
                );
            case "shipmentUnit":
                return (
                    <AbstractSelect
                        options={{
                            ...options,
                            data: [
                                {
                                    value: "cases",
                                    text: intl.formatMessage({ id: "shipmentUnit.cases" }),
                                },
                                {
                                    value: "ton",
                                    text: intl.formatMessage({ id: "shipmentUnit.ton" }),
                                },
                                {
                                    value: "kg",
                                    text: intl.formatMessage({ id: "shipmentUnit.kg" }),
                                },
                                {
                                    value: "pallet",
                                    text: intl.formatMessage({ id: "shipmentUnit.pallet" }),
                                },
                                {
                                    value: "meter",
                                    text: intl.formatMessage({ id: "shipmentUnit.meter" }),
                                },
                            ],
                        }}
                        errors={errors}
                        entityObject={entityObject}
                        register={register}
                    />
                );
            case "string":
                return (
                    <AbstractString
                        options={options}
                        errors={errors}
                        entityObject={entityObject}
                        register={register}
                    />
                );
            default:
                break;
        }
    };
    return (
        <EuiFlexItem>
            <EuiFlexGroup
                gutterSize="none"
                responsive={false}
                className="dropoff-section-container"
            >
                <EuiFlexItem
                    grow={false}
                    className="dropoff-section-container__icon"
                >
                    <EuiIcon type={iconType} />
                </EuiFlexItem>
                <EuiFlexItem>
                    <EuiDescriptionList>
                        <EuiDescriptionListTitle>
                            <EuiText size="s">{title}</EuiText>
                        </EuiDescriptionListTitle>
                        <EuiDescriptionListDescription>
                            <form>
                                <b>{mapDropOffValue(fieldType, value)}</b>

                                {isLoading ? (
                                    <EuiLoadingSpinner
                                        style={{ marginLeft: 10 }}
                                        size="m"
                                    />
                                ) : fieldType === "attachment" ? (
                                    <EuiButtonEmpty
                                        size="xs"
                                        onClick={openPopover}
                                    >
                                        <b>
                                            <FormattedMessage id="action.view" />
                                        </b>
                                    </EuiButtonEmpty>
                                ) : (
                                    isEditable && (
                                        <TripFieldForm
                                            openPopover={openPopover}
                                            isPopoverOpen={isPopoverOpen}
                                            closePopover={closePopover}
                                            input={renderInput()}
                                            onSubmit={handleSubmit(onSubmit)}
                                            isLoading={isLoading}
                                        />
                                    )
                                )}
                            </form>
                        </EuiDescriptionListDescription>
                    </EuiDescriptionList>
                </EuiFlexItem>
            </EuiFlexGroup>
            {fieldType === "attachment" && isPopoverOpen && (
                <DocumentsModal
                    onClose={closePopover}
                    onSubmit={onSubmit}
                    defaultValue={value}
                    onDelete={(attachement) => onSubmit(attachement, successCallBack)}
                    isLoading={isLoading}
                    isEditable={isEditable}
                    title={pointName}
                />
            )}
        </EuiFlexItem>
    );
}

export default DropoffAccordionSection;
